import { service } from "@server/client";
import type {
  AddPromotionToCartMutation,
  AddPromotionToCartMutationVariables,
} from "@server/gql/graphql";
import { addPromotionMutation as addPromotionToCartMutation } from "@server/queries/cart";

export const addPromotionToCart = async (
  variables: AddPromotionToCartMutationVariables,
) => {
  try {
    const response = await service<
      AddPromotionToCartMutation,
      AddPromotionToCartMutationVariables
    >({
      query: addPromotionToCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in addPromotionToCart", error);
    throw error;
  }
};
